export enum MasterLocationApiUrls {
    GetPostalCodes ='/api/Location/GetPostalCodes',
    GetTagsLookup='/api/Tag/GetTagsLookup',
    GetPublicLocations='/api/Location/GetPublicLocations',
    GetPublicLocationsForPP='/api/Location/GetPublicLocationsForPP',
    GetPrivateLocationsForAutoComplete = '/api/Location/GetPrivateLocationsForAutoComplete',
    GetPrivateLocationDetails = '/api/Location/GetPrivateLocationDetails',
    GetSegments = '/api/Location/GetSegments',
    ImportPlanContainerLocations = '/api/PlanContainer/ImportPlanContainersLocationUsingCsvFile',
    DeleteMasterLocation = '/api/PlanContainer/DeleteContainerLocation',
    AddNewPlanLocation = '/api/Location/AddNewPlanLocation',
    GetLocationTypes = '/api/Location/GetLocationTypes',
    GetActivitiesByProduct = '/api/ProductActivity/GetActivitiesByProduct',
    GetMLSFilters='/api/Filter/GetFilters'
  }